
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/page/[subdomain]",
      function () {
        return require("private-next-pages/page/[subdomain]/index.tsx");
      }
    ]);
  